import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "react-router-dom";
import { connect } from "react-redux";
import standVirtualRoutes from "../stand-virtual/standVirtualRoutes";
import { routes } from "../../routes/app-routes";

const PrivateRoute = (props) => {
  const {
    component: Component,
    isStandVirtualOnly = false,
    blockStandVirtualAdmin = false,
    requiredPermissions = [],
    ...rest
  } = props;

  const { isAuth, isStandVirtualAdmin, prestador, isEmailUser } = props?.authUserData || {};

  const getRedirectPath = () => {
    if (!isAuth) {
      return routes.login;
    }

    // Check if email user has no roles configured
    const userRoles = prestador?.roles || [];
    const hasEmailSymbol = (typeof prestador?.codigo === 'string' && prestador?.codigo?.includes("@")) || prestador?.email?.includes("@") || isEmailUser;
    
    if (hasEmailSymbol && userRoles.length === 0) {
      return routes.unauthorized;
    }

    if (requiredPermissions.length > 0) {
      const hasPermission = requiredPermissions.every((permission) =>
        prestador?.permisos?.includes(permission)
      );
      if (!hasPermission) {
        return routes.unauthorized;
      }
    }

    if (isStandVirtualOnly && !isStandVirtualAdmin) {
      return routes.unauthorized;
    }

    if (blockStandVirtualAdmin && isStandVirtualAdmin) {
      return `/${standVirtualRoutes.base.route}/${standVirtualRoutes.dashboard.main.route}`;
    }

    return null;
  };

  const redirectPath = getRedirectPath();

  return (
    <Route
      {...rest}
      render={(prop) => {
        if (redirectPath) {
          return (
            <Redirect
              to={{
                pathname: redirectPath,
                state: {
                  from: prop.location,
                  requiredPermissions: requiredPermissions
                }
              }}
            />
          );
        }

        return <Component {...prop} />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
  isStandVirtualOnly: PropTypes.bool,
  blockStandVirtualAdmin: PropTypes.bool,
  requiredPermissions: PropTypes.arrayOf(PropTypes.string),
  authUserData: PropTypes.object,
  authUserLoading: PropTypes.bool,
  authUserError: PropTypes.object
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PrivateRoute);
